var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.btnForm.status),expression:"btnForm.status"}],staticClass:"home-btn primary",style:(_vm.btnStyle),on:{"click":_vm.goLink}},[_vm._v("\n    "+_vm._s(_vm.$getConfigText(_vm.btnForm.buttonText))+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-535fd964","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/templates/blocks/block-btn.vue
// module id = null
// module chunks = 